// src/services/roleService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}roles`;

class RoleService {
  getAll() {
    return axios.get(API_URL, { headers: buildHeaders() });
  }

  create(roleData) {
    return axios.post(API_URL, roleData, { headers: buildHeaders() });
  }
  update(roleId, roleData) {
    return axios.put(`${API_URL}/${roleId}`, roleData, {
      headers: buildHeaders(),
    });
  }
  delete(roleId) {
    return axios.delete(`${API_URL}/${roleId}`, { headers: buildHeaders() });
  }

  assignPermissions(roleId, permissions) {
    return axios.post(
      `${API_URL}/${roleId}/permissions`,
      { permissions },
      { headers: buildHeaders() }
    );
  }
}

export default new RoleService();
